var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-dialog',{attrs:{"auto-width":"","not-padding":"","not-close":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('div',{staticClass:"con-form"},[_c('pdf',{ref:"pdf",attrs:{"src":_vm.url}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }